export default __webpack_public_path__ + "static/media/Em.0c8a79fb.jpg";